import type en from '../en/starlink'
import type { Translation } from '../types'

/** Starlink: the terminals, a site's and an event's cards, the business account */
const starlink: Translation<typeof en> = {
  "starlink.title": "Terminales de Starlink",
  "starlink.subtitle": "Los terminales de Starlink de la empresa: su sitio o evento, en línea, los datos usados y su servicio",
  "starlink.search": "Buscar terminales de Starlink",
  "starlink.refresh": "Actualizar",
  "starlink.refreshed": "Cuentas de Starlink leídas",
  "starlink.refreshFailed": "No se leyeron las cuentas de Starlink",
  "starlink.addByKit": "Añadir por número de kit",
  "starlink.addHint": "Un terminal con un plan personal, sin cuenta empresarial: muestra lo que Velanox sabe de él — su sitio y su artículo de alquiler.",
  "starlink.kitSerial": "Número de kit",
  "starlink.nickname": "Nombre (opcional)",
  "starlink.add": "Añadir",
  "starlink.added": "Starlink añadido",
  "starlink.addFailed": "Starlink no añadido",
  "starlink.none": "Aún no hay terminales de Starlink. Añada la cuenta empresarial de la empresa en Configuración de la empresa → Conexiones, o añada un terminal por su número de kit.",
  "starlink.col.terminal": "Terminal",
  "starlink.col.site": "Sitio o evento",
  "starlink.col.online": "En línea",
  "starlink.col.data": "Datos",
  "starlink.col.service": "Servicio",
  "starlink.online": "En línea",
  "starlink.offline": "Sin conexión",
  "starlink.lastRead": "Última lectura {when}",
  "starlink.notRead": "Aún no leído",
  "starlink.noAccount": "Sin cuenta",
  "starlink.notListed": "Ya no está en su cuenta",
  "starlink.data": "{used} de {plan} GB",
  "starlink.dataNoLimit": "{used} GB",
  "starlink.serviceOn": "Activado",
  "starlink.serviceOff": "Desactivado",
  "starlink.serviceUnknown": "Desconocido",
  "starlink.switching": "Cambiando…",
  "starlink.event": "Evento: {name}",
  "starlink.linkToSite": "Vincular a un sitio",
  "starlink.site": "Sitio",
  "starlink.noSite": "Ningún sitio",
  "starlink.linked": "Starlink vinculado",
  "starlink.linkFailed": "Starlink no vinculado",
  "starlink.save": "Guardar",
  "starlink.remove": "Eliminar",
  "starlink.removeConfirm": "¿Eliminar {name}? Un terminal que siga en su cuenta vuelve en la próxima lectura, sin sitio.",
  "starlink.removed": "Starlink eliminado",
  "starlink.removeFailed": "Starlink no eliminado",
  "starlink.card.lastSeen": "Visto por última vez {when}",
  "starlink.card.neverSeen": "Nunca se ha recibido nada",
  "starlink.card.alerts": "La antena informa: {alerts}",
  "starlink.card.data": "Datos de este ciclo de facturación",
  "starlink.card.noLimit": "Su plan no tiene límite de datos",
  "starlink.card.noData": "No se conoce el uso de datos",
  "starlink.card.service": "Servicio",
  "starlink.card.onConfirm": "¿Activar el servicio de este Starlink? Puede tener un coste.",
  "starlink.card.offConfirm": "¿Desactivar el servicio de este Starlink?",
  "starlink.card.switched": "Servicio cambiado",
  "starlink.card.switchFailed": "Servicio no cambiado",
  "starlink.card.inApp": "Cámbielo en la aplicación de Starlink: su plan no se puede pausar desde aquí.",
  "starlink.card.pending": "Starlink aún no ha aplicado el cambio: se vuelve a intentar cada 5 minutos.",
  "starlink.card.noAccount": "Sin cuenta empresarial: utilice la app de Starlink para su consumo de datos y su servicio.",
  "starlink.eventCard.none": "No hay terminales de Starlink en este evento.",
  "starlink.eventCard.switchedOn": "Activado",
  "starlink.eventCard.switchedOff": "Desactivado",
  "starlink.eventCard.notTaken": "no aplicado por Starlink",
  "starlink.eventCard.withEvent": "con el evento",
  "starlink.eventCard.by": "por {name}",
  "starlink.eventCard.noSwitches": "Aún no se ha cambiado para este evento",
  "starlink.account.title": "Cuenta empresarial de Starlink",
  "starlink.account.intro": "El ID de cliente y el secreto de una cuenta de servicio de la cuenta empresarial de Starlink de la empresa. Velanox lee sus terminales cada 5 minutos y cambia su servicio con sus eventos.",
  "starlink.account.name": "Nombre",
  "starlink.account.clientId": "ID de cliente",
  "starlink.account.clientSecret": "Secreto de cliente",
  "starlink.account.secretKept": "Déjelo vacío para conservar el secreto",
  "starlink.account.save": "Probar y guardar",
  "starlink.account.saved": "Cuenta de Starlink guardada",
  "starlink.account.terminals": "Terminales",
  "starlink.edit": "Editar",
  "starlink.saved": "Starlink guardado",
  "starlink.saveFailed": "Starlink no guardado",
  "starlink.dish.title": "Antena Starlink",
  "starlink.dish.auto": "Automático",
  "starlink.dish.wan": "Solo {wan}",
  "starlink.dish.off": "Desactivado",
  "starlink.dish.lookAgain": "Buscar de nuevo",
  "starlink.dish.looking": "Buscando…",
  "starlink.dish.found": "Encontrada en {wan}",
  "starlink.dish.notFound": "No se ha encontrado ningún Starlink detrás de este router",
  "starlink.dish.failed": "No se han podido escribir las reglas: {reason}",
  "starlink.dish.turnedOff": "Velanox no busca ninguna antena Starlink detrás de este router",
  "starlink.dish.notChanged": "No se ha cambiado el ajuste de la antena Starlink",
  "starlink.dish.block": "Antena",
  "starlink.dish.signalOk": "Señal buena",
  "starlink.dish.signalLow": "Señal débil",
  "starlink.dish.obstructed": "Obstruida {pct} %",
  "starlink.dish.obstructedNow": "obstruida ahora",
  "starlink.dish.speed": "Bajada {down} · Subida {up} Mbps",
  "starlink.dish.latency": "Latencia {ms} ms",
  "starlink.dish.drop": "{pct} % de pings perdidos",
  "starlink.dish.stowed": "Plegada",
  "starlink.dish.reachedVia": "Alcanzada a través de {site}",
  "starlink.dish.notReachedSince": "No alcanzada desde {when}",
  "starlink.dish.notReached": "No alcanzada",
  "starlink.dish.reboot": "Reiniciar",
  "starlink.dish.stow": "Plegar",
  "starlink.dish.unstow": "Desplegar",
  "starlink.dish.rebootConfirm": "¿Reiniciar esta antena? Su conexión se cae durante unos minutos.",
  "starlink.dish.stowConfirm": "¿Plegar esta antena? Se pliega en plano y su conexión se detiene.",
  "starlink.dish.unstowConfirm": "¿Desplegar esta antena?",
  "starlink.dish.done": "Enviado a la antena",
  "starlink.dish.actionFailed": "La antena no lo ha hecho",
}

export default starlink
